import { render, staticRenderFns } from "./SlabsNew.vue?vue&type=template&id=b9d73862&scoped=true"
import script from "./SlabsNew.vue?vue&type=script&lang=js"
export * from "./SlabsNew.vue?vue&type=script&lang=js"
import style0 from "./SlabsNew.vue?vue&type=style&index=0&id=b9d73862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d73862",
  null
  
)

export default component.exports